window.themeVariables.LanguageSwitcher = (function () {
    console.log("Custom Language Switcher!");
    const selectors = {
        countriesData: "#countriesData",
        countryContent: ".country-content",
        locationUrl: "/browsing_context_suggestions",
        languageChanger: ".lang-changer",
        countryChangers: ".country-button",
        close: ".fancy-shop-change-closebutton",
        redirectRules: {
            "FR": ["be", "fr"],
            "DE": ["de", "at", "ch"],
        }
    };

    function LanguageSwitcher() {
        this.countryContent = JSON.parse(document.querySelector("#countriesData").innerHTML).Countries;
        this.languageChanger = document.querySelectorAll(selectors.languageChanger);
        this.closeFancyRedirections = document.querySelectorAll(selectors.close);
        this.countryChangers = document.querySelectorAll(selectors.countryChangers);
        this._init();
    }

    LanguageSwitcher.prototype = Object.assign({}, LanguageSwitcher.prototype, {
        _init: async function () {
            this._bindEvents();
            if (!this.countryContent.length) return;
            this.loadedData = await this._loadLocations();
            this._redirect();
        },

        _bindEvents: function () {
            // Redirection pop-up close event
            this.closeFancyRedirections.forEach((closer) => {
                closer.addEventListener("click", function (event) {
                    if (event.currentTarget.closest(".country-content")) {
                        event.currentTarget.closest(".country-content").style.display = "none";
                        localStorage.setItem("fancy-redirection", false);
                    }
                });
            });

            this.languageChanger.forEach((switcher) => {
                switcher.addEventListener("click", function (event) {
                    window.location.href = event.currentTarget.getAttribute("data-value");
                });
            });
            this.countryChangers.forEach((countryChanger) => {
                countryChanger.addEventListener("click", function (event) {
                    let link = event.currentTarget.getAttribute("data-link");
                    console.log(link);
                    window.location.href = link; //open in same tab
                });
            });
        },

        _loadLocations: async function () {
            return await fetch(selectors.locationUrl).then((response) => response.json());
        },

        _redirect: function () {
            // Get stores url;
            let windowOrigin = (window.location.origin).split(".")[1] //("https://holyenergy.fr").split(".")[1];
            let currentLocation = (this.loadedData.detected_values.country.handle).toLowerCase();
            let FRstoreRules = selectors.redirectRules.FR;
            let DEstoreRules = selectors.redirectRules.DE;
            let isOrigin = windowOrigin === currentLocation;
            let redirectElement;
            if (FRstoreRules.indexOf(currentLocation) > -1 && !isOrigin) {
                //console.log("Redirect to fr store");
                redirectElement = document.querySelector(`${selectors.countryContent}[data-redirect-country='FR']`);
            }
            if (DEstoreRules.indexOf(currentLocation) > -1 && !isOrigin) {
                //console.log("Redirect to DE store");
                redirectElement = document.querySelector(`${selectors.countryContent}[data-redirect-country='DE']`);
            }
            redirectElement ? (redirectElement.style.display = "inline-flex", window.scrollTo({ top: 0, behaviour: "smooth" })) : null;

        }
    });
    return LanguageSwitcher;
})();

if (window.themeVariables.settings.customLanguageSwitcher) {
    new window.themeVariables.LanguageSwitcher();
}